import { Grid } from 'antd';
import styled from 'styled-components';
import Menus from './Menus';
import { SidebarStyled } from './styled/Sidebar.Styled';

export const Backdrop = styled.div`
    position: absolute;
    z-index: -99999;
    top: 0;
    left: 0;
    opacity: 0.5;
    background: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100vw;
    transition: all ease 0.3s;
`;

function Sidebar({ collapsed, setCollapsed }) {
    const { md } = Grid.useBreakpoint();
    const isMobile = !md;

    return (
        <SidebarStyled $isMobile={isMobile} collapsible collapsed={isMobile ? collapsed : false} trigger={null} width={280} id="em-sidebar">
            {isMobile && <Backdrop onClick={() => setCollapsed((prev) => !prev)} />}
            <div id="em-menus">
                <Menus />
            </div>
        </SidebarStyled>
    );
}

export default Sidebar;
